import React from 'react';
import {BounceLoader} from 'halogenium';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const PageLoader = ({fullScreen, size, fullHeight, color}) => {
  const wrapperClasses = classNames(
    'page-loader', {
      'page-loader_full': fullScreen,
      'page-loader_fullheight': !fullScreen && fullHeight,
    }
  );
  const loaderClasses = classNames(
    'page-loader_indicator',
    `page-loader_indicator-${size}`
  );
  const sizeDictionary = {
    xl: 128,
    l: 100,
    m: 80,
    s: 60,
  };
  const loaderSize = sizeDictionary[size];

  return (
    <div className={wrapperClasses}>
      <div className={loaderClasses}>
        <BounceLoader color={color} size={loaderSize}/>
      </div>
    </div>
  );
};

PageLoader.propTypes = {
  fullScreen: PropTypes.bool,
  fullHeight: PropTypes.bool,
  size: PropTypes.string,
  color: PropTypes.string,
};

PageLoader.defaultProps = {
  fullScreen: false,
  fullHeight: false,
  size: 'l',
  color: '#f15a24',
};

export default PageLoader;
